import React from "react";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import classes from "./EventDates.module.css";

const EventDates = ({ eventFromDate, eventToDate, className = "", datesClassName = "", iconSize = "14px", iconColor = "#333" }) => {

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        return `${day}/${month}`;
    };

    const formatTime = (date) => {
        const d = new Date(date);
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    return (
        <>
            {eventFromDate && eventToDate && <div className={`${classes.EventDates} ${className}`}>
                <Icon name={iconsList.calendar} size={iconSize} color={iconColor} />
                <span className={`${classes.Dates} ${datesClassName}`}>
                    {formatDate(eventFromDate)} | {formatTime(eventToDate)} - {formatTime(eventFromDate)}
                </span>
            </div>}
        </>
    );
};

export default EventDates;
